const engToRus = {
    a: 'а',
    b: 'б',
    c: 'с',
    d: 'д',
    e: 'е',
    f: 'ф',
    g: 'г',
    i: 'и',
    j: 'и',
    h: 'н',
    k: 'к',
    l: 'л',
    m: 'м',
    n: 'н',
    o: 'о',
    p: 'п',
    q: 'к',
    r: 'р',
    s: 'с',
    t: 'т',
    u: 'у',
    v: 'в',
    w: 'в',
    x: 'х',
    y: 'у',
    z: 'з',
};
export function translitToRus(str = '') {
    return String(str)
        .toLowerCase()
        .split('')
        .map((letter) => {
        return engToRus[letter] || letter;
    })
        .join('');
}
